import React from 'react';
import { Provider } from 'unistore/react';
import { IntlContextProvider } from 'common/components/Intl';
import { configureLocales } from 'common/locales';
import { store } from './store/PlanStore';
import BuildYourPlan from './components/BuildYourPlan';

export default class BuildYourPlanApp extends React.Component {
  render() {
    configureLocales(this.props.intlContext.locale);

    return (
      <Provider store={store}>
        <IntlContextProvider {...this.props.intlContext}>
          <BuildYourPlan {...this.props} />
        </IntlContextProvider>
      </Provider>
    );
  }
}
